import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import * as fromAuth from 'core/auth/state'
import * as fromLanguage from 'core/language/state'

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export interface RootState {
    [fromAuth.FEATURE_NAME]: fromAuth.State
    [fromLanguage.FEATURE_NAME]: fromLanguage.State
}

const reducers = combineReducers<RootState>({
    [fromAuth.FEATURE_NAME]: fromAuth.reducer,
    [fromLanguage.FEATURE_NAME]: fromLanguage.reducer
})

export const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)))
